import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_PRISTINE_UYO} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {deriveIdFromCanvasObject} from '~/CreateFabricInvitation/utils/canvas';

export const useUYO = ({canvas}) => {
  const dispatch = useDispatch();

  const getUYOImageInfo = () => {
    if (!canvas) return {};

    const activeObject = canvas.getActiveObject();
    if (activeObject?.type === 'uYOImage') {
      // eslint-disable-next-line no-underscore-dangle
      const id = activeObject?.id || deriveIdFromCanvasObject(activeObject._originalObject);
      return {
        uyoImage: activeObject,
        id,
      };
    }
    return {};
  };

  const handleImageUploaded = useCallback(
    (uyoImage, id) => {
      dispatch({
        type: UPDATE_PRISTINE_UYO,
        payload: {pristineUyo: false, id, objects: canvas.getObjects()},
      });
      canvas.setActiveObject(uyoImage).renderAll();
    },
    [canvas]
  );

  return {
    getUYOImageInfo,
    handleImageUploaded,
  };
};
